import {
    ButtonPrimary,
    Text3,
    ButtonFixedFooterLayout,
    Text2,
    Tag,
    ButtonSecondary,
    Text1,
    Text4,
    IconChevronLeftRegular,
    NavigationBar,
    skinVars,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import { DataCard } from '@telefonica/mistica';
import ButtonGroup from '@telefonica/mistica/dist/button-group';
import navigateParams from '../../../../../utils/navigation/navigateParams';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getCustomerData, sendContactVerificationOTP } from '../../../../../services/CustomerService';
import { showSpinner, hideSpinner } from '../../../../../utils/store/features/user';
import { formatMobileNumber } from '../../../../../utils/dataTransformation/unitsConversion';
import ChangePersonalData from '../../../../profile/personalData/changePersonalData';
import ContactInfoVerificationOTP from '../contactInfoVerificationOTP';
import { AxiosError, AxiosResponse } from 'axios';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { useQuery } from '@tanstack/react-query';

export interface ContactInfoVerificationStep1Interface {
    fromDesktop?: boolean;
    setComponentSelected?: any;
}

export const ContactInfoVerificationStep1: React.FC<ContactInfoVerificationStep1Interface> = ({
    fromDesktop,
    setComponentSelected,
}: ContactInfoVerificationStep1Interface) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { trackingScreenView } = new TrackingEvents();

    const {
        data: personalData,
        isError,
        isSuccess,
    } = useQuery({
        queryKey: ['customer-data'],
        queryFn: getCustomerData,
    });

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        dispatch(showSpinner());
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // TODO: check if this useEffect works fine
    useEffect(() => {
        if (isError || isSuccess) {
            dispatch(hideSpinner());
        }
    }, [isError, isSuccess]);

    const sendToNative = (url: string, typeVerification: string, fromOnboarding?: boolean) => {
        const data = {
            typeVerification: typeVerification,
            fromOnboarding: fromOnboarding,
            currentMobile: personalData?.data.contactNumber?.value,
            currentEmail: personalData?.data.email?.value,
        };
        navigate(
            url +
                '?typeVerification=' +
                typeVerification +
                '&fromOnboarding=' +
                fromOnboarding +
                '&currentMobile=' +
                data.currentMobile +
                '&currentEmail=' +
                data.currentEmail,
            { state: data },
        );
    };

    const sendToFeedback = (url: string, description: string, type: string, title: string) => {
        const queryParams = {
            state: description,
            title: 'Solicitud realizada',
            subtitle: 'Tus medios de contacto se han verificado correctamente.',
        };
        const storage = {};
        const feedbackData = {
            stateFeedback: description,
        };
        if (navigateParams(type, url, queryParams, storage, title)) {
            navigate(url, { state: feedbackData });
        }
    };

    const handleButtonContinue = () => {
        let success: boolean = true;
        if (success) {
            sendToFeedback('/obd/verify/feedback', 'SUCCESS', 'feedback-success', '');
        }
    };
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    const verifyOTPSend = (type: string) => {
        const contact = type === 'mobile' ? personalData?.data.contactNumber?.value : personalData?.data.email?.value;
        contact &&
            sendContactVerificationOTP(contact)
                .then((response: AxiosResponse) => {
                    if (type === 'mobile') {
                        if (fromDesktop) {
                            setComponentSelected(
                                <ContactInfoVerificationOTP
                                    fromDesktop={fromDesktop}
                                    setComponentSelected={setComponentSelected}
                                    typeVerificationDesktop={'mobile'}
                                    currentMobileDesktop={personalData?.data.contactNumber?.value}
                                    currentEmailDesktop={personalData?.data.email?.value}
                                ></ContactInfoVerificationOTP>,
                            );
                        } else {
                            sendToNative('/obd/verify/otp', 'mobile');
                        }
                    } else {
                        if (fromDesktop) {
                            setComponentSelected(
                                <ContactInfoVerificationOTP
                                    fromDesktop={fromDesktop}
                                    setComponentSelected={setComponentSelected}
                                    typeVerificationDesktop={'email'}
                                    currentMobileDesktop={personalData?.data.contactNumber?.value}
                                    currentEmailDesktop={personalData?.data.email?.value}
                                ></ContactInfoVerificationOTP>,
                            );
                        } else {
                            sendToNative('/obd/verify/otp', 'email');
                        }
                    }
                })
                .catch((error: AxiosError) => {});
    };
    return (
        <div className='contact-info-verification-step1'>
            {windowWidth < 1024 && (
                <>
                    {isWebviewAndroid || isWebviewIOS ? (
                        <div
                            className='contact-info-verification-step1__header-navigationBar'
                            style={{
                                background: skinVars.colors.navigationBarBackground,
                                height:
                                    isWebviewAndroid || isWebviewIOS ? '44px' : windowWidth >= 1024 ? '80px' : '56px',
                            }}
                        >
                            <Text4 regular color={skinVars.colors.textNavigationBarPrimary}>
                                {t('titleContactInfoVerification')}
                            </Text4>
                        </div>
                    ) : (
                        <NavigationBar title={t('titleContactInfoVerification')} onBack={() => navigate(-1)} />
                    )}
                    <div
                        className='contact-info-verification-step1__header-return'
                        onClick={() => {
                            navigate(-1);
                        }}
                    >
                        <div className='contact-info-verification-step1__header-return-icon'>
                            <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                        </div>
                        <Text2 medium color={skinVars.colors.appBarBackground}>
                            {t('returnResponsive')}
                        </Text2>
                    </div>
                </>
            )}
            <ButtonFixedFooterLayout
                button={
                    <ButtonPrimary
                        disabled={!personalData?.data.email?.verified && !personalData?.data.contactNumber?.verified}
                        onPress={() => handleButtonContinue()}
                    >
                        {t('next')}
                    </ButtonPrimary>
                }
            >
                <div className='contact-info-verification-step1__text1'>
                    <Text3 regular color={skinVars.colors.textPrimary}>
                        {t('contactVerificationStep1Title')}
                    </Text3>
                </div>
                <div className='contact-info-verification-step1__text2'>
                    <Text2 regular color={skinVars.colors.textSecondary}>
                        {t('contactVerificationStep1Subtitle')}
                    </Text2>
                </div>
                <div className='contact-info-verification-step1__cards'>
                    <DataCard
                        title={''}
                        headline={
                            <Tag type={personalData?.data.contactNumber?.verified ? 'success' : 'inactive'}>
                                {personalData?.data.contactNumber?.verified
                                    ? t('contactVerificationStep1Verified')
                                    : t('contactVerificationStep1NotVerified')}
                            </Tag>
                        }
                        extra={
                            <div className='contact-info-verification-step1__cards__extra'>
                                <div className='contact-info-verification-step1__cards__extra__texts'>
                                    <div className='contact-info-verification-step1__cards__extra__texts__1'>
                                        <Text1 regular>{t('contactVerificationStep1MobileText')}</Text1>
                                    </div>
                                    <div className='contact-info-verification-step1__cards__extra__texts__2'>
                                        <Text4 regular>
                                            {formatMobileNumber(personalData?.data.contactNumber?.value)}
                                        </Text4>
                                    </div>
                                </div>
                                {!personalData?.data.contactNumber?.verified && (
                                    <div className='contact-info-verification-step1__cards__extra__buttons'>
                                        <ButtonGroup
                                            primaryButton={
                                                <ButtonPrimary
                                                    small
                                                    onPress={() => {
                                                        verifyOTPSend('mobile');
                                                    }}
                                                >
                                                    {t('contactVerificationStep1ButtonVerify')}
                                                </ButtonPrimary>
                                            }
                                            secondaryButton={
                                                <ButtonSecondary
                                                    small
                                                    onPress={() => {
                                                        if (fromDesktop) {
                                                            setComponentSelected(
                                                                <ChangePersonalData
                                                                    fromDesktop={fromDesktop}
                                                                    setComponentSelected={setComponentSelected}
                                                                    typeVerificationDesktop={'mobile'}
                                                                    fromOnboardingDesktop={'true'}
                                                                    currentMobileDesktop={
                                                                        personalData?.data.contactNumber?.value
                                                                    }
                                                                    currentEmailDesktop={
                                                                        personalData?.data.email?.value
                                                                    }
                                                                ></ChangePersonalData>,
                                                            );
                                                        } else {
                                                            sendToNative(
                                                                '/profile/personal-data/change',
                                                                'mobile',
                                                                true,
                                                            );
                                                        }
                                                    }}
                                                >
                                                    {t('contactVerificationStep1ButtonEdit')}
                                                </ButtonSecondary>
                                            }
                                        ></ButtonGroup>
                                    </div>
                                )}
                            </div>
                        }
                    />
                    <DataCard
                        headline={
                            <Tag type={personalData?.data.email?.verified ? 'success' : 'inactive'}>
                                {personalData?.data.email?.verified
                                    ? t('contactVerificationStep1Verified')
                                    : t('contactVerificationStep1NotVerified')}
                            </Tag>
                        }
                        extra={
                            <div className='contact-info-verification-step1__cards__extra'>
                                <div className='contact-info-verification-step1__cards__extra__texts'>
                                    <div className='contact-info-verification-step1__cards__extra__texts__1'>
                                        <Text1 regular>{t('contactVerificationStep1EmailText')}</Text1>
                                    </div>
                                    <div className='contact-info-verification-step1__cards__extra__texts__2'>
                                        <Text4 regular>{personalData?.data.email?.value}</Text4>
                                    </div>
                                </div>
                                {!personalData?.data.email?.verified && (
                                    <div className='contact-info-verification-step1__cards__extra__buttons'>
                                        <ButtonGroup
                                            primaryButton={
                                                <ButtonPrimary
                                                    small
                                                    onPress={() => {
                                                        verifyOTPSend('email');
                                                    }}
                                                >
                                                    {t('contactVerificationStep1ButtonVerify')}
                                                </ButtonPrimary>
                                            }
                                            secondaryButton={
                                                <ButtonSecondary
                                                    small
                                                    onPress={() => {
                                                        if (fromDesktop) {
                                                            setComponentSelected(
                                                                <ChangePersonalData
                                                                    fromDesktop={fromDesktop}
                                                                    setComponentSelected={setComponentSelected}
                                                                    typeVerificationDesktop={'email'}
                                                                    currentMobileDesktop={
                                                                        personalData?.data.contactNumber?.value
                                                                    }
                                                                    currentEmailDesktop={
                                                                        personalData?.data.email?.value
                                                                    }
                                                                    fromOnboardingDesktop={'true'}
                                                                ></ChangePersonalData>,
                                                            );
                                                        } else {
                                                            sendToNative(
                                                                '/profile/personal-data/change',
                                                                'email',
                                                                true,
                                                            );
                                                        }
                                                    }}
                                                >
                                                    {t('contactVerificationStep1ButtonEdit')}
                                                </ButtonSecondary>
                                            }
                                        ></ButtonGroup>
                                    </div>
                                )}
                            </div>
                        }
                    />
                </div>
            </ButtonFixedFooterLayout>
        </div>
    );
};

export default ContactInfoVerificationStep1;
